import { Component, Host, h, Prop } from '@stencil/core';

/**
 * @slot media - Shadow Dom Slot to place Media Item (e.g. picture / image)
 * @slot cta - Shadow Dom Slot where you can add a Call-To-Action Button (vds-button)
 */
@Component({
  tag: 'vds-teaser-quote',
  styleUrl: 'vds-teaser-quote.scss',
  shadow: true,
})
export class VdsTeaserQuote {

  /**
   * Headline for the Content Modules
   * Mandatory: no
   * Max Chars: 50
   */
   @Prop() headline = '';

   /**
    * Text-Content
    * Mandatory: no
    */
  @Prop() copy = '';

  /**
    * Text-Content above the media element
    * Mandatory: no
    */
   @Prop() source = '';

  /**
    * Controls wether the CTA Button is displayed or not
    */
   @Prop({ reflect: true }) showCta = false;


  render() {
    return (
      <Host>
        <div class="relative grid grid-cols-3 gap-y-6 sm:gap-y-0 sm:gap-x-15">
          <div class="col-span-3 sm:col-span-1">
            <slot name="media"></slot>
          </div>
          <div class="col-span-3 sm:col-span-2">
            <h2 class="font-heavy text-h2-mobile sm:text-h2-tablet lg:text-h2-desktop text-grey uppercase mb-2 break-words" innerHTML={this.headline}></h2>
            <blockquote class="mb-6">
              <p class="font-regular text-quote-mobile sm:text-quote-tablet lg:text-quote-desktop text-grey" innerHTML={this.copy}></p>
              <footer class="font-regular text-sm text-grey mt-2" innerHTML={this.source}></footer>
            </blockquote>
            { this.renderCta() }
          </div>
        </div>
      </Host>
    );
  }

  private renderCta(): string {
    if(this.showCta) {
      return (
        <slot name="cta"></slot>
      );
    }
  }

}
